import React from 'react';
import Page from "../BaseComponents/Page/Page";
import PropTypes from 'prop-types'
import {FaRegularIcon, FaSolidIcon} from "../FontAwesomeIcons";
import BookingAPI from "../../api/BookingAPI";
import './DateTimeChooserPage.css';
import moment from "moment";
import {swal, swalError, swalLoading} from "../../helpers/SweetAlertWrapper";
import {PageFooter, PageWithFooterContainer} from "../BaseComponents/Page/PageFooter";

export default class DateChooserPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            onDismiss: props.onDismiss,
            onChoose: props.onChoose,
            selectedDate: null,
            selectedTime: null,
            dateDisponibili: {},
            startDate: 'now',
            requestDirection: 'next',
            nextButtonClicks: 0,
            datesHistory: {}
        };

        this.needRefetch = true;


        this.handleDismiss = this.handleDismiss.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleNextDays = this.handleNextDays.bind(this);
        this.handlePrevDays = this.handlePrevDays.bind(this);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.timesContainerStyle = {
            maxHeight: "calc(100vh - 44px - 80px - 195px)", //44px page header, 80px page footer, 195px dates container
            overflowY: 'auto',
            marginTop: 1
        }
    }

    componentDidMount() {
    }

    fetchNewData() {
        var state = {};
        swalLoading("Recupero date e orari disponibili...");

        //Questo calcolo di startDate permette di non includere la startDate tra le date prossime date richieste
        const startDate = this.state.startDate === 'now' ?
            //Se non ho una data di partenza uso quella attuale
            moment().format('DD-MM-YYYY') :
            this.state.requestDirection === 'next' ?
                //Se sto andando avanti allora devo partire dal giorno successivo all'ultima data disponibile (this.state.startDate)
                moment(this.state.startDate, 'DD-MM-YYYY').add(1, 'day').format('DD-MM-YYYY')
                :
                //Se sto andando indietro allora devo partire dal giorno precedente alla prima data disponibile (this.state.startDate)
                moment(this.state.startDate, 'DD-MM-YYYY').subtract(1, 'day').format('DD-MM-YYYY');

        BookingAPI.getAvailableDates(startDate, this.state.requestDirection, this.props.bookInfo.id_sede, this.props.bookInfo.id_dipendente, this.props.bookInfo.id_servizio, this.props.bookInfo.repeat || 1, this.props.bookInfo.ignore_book_ids)
            .then((dateDisponibili) => {
                if (Object.keys(dateDisponibili).length > 0) {

                    state.dateDisponibili = dateDisponibili;
                    state.selectedDate = Object.keys(dateDisponibili)[0];

                    /**
                     * In caso di direction "prev" allora rimuovo le date attualmente visualizzate dalla history,
                     * prima di sostituirle con quelle appena fetchate
                     */
                    state.datesHistory = {...this.state.datesHistory};
                    if (this.state.requestDirection === "prev") {
                        Object.keys(this.state.dateDisponibili).map(d => delete state.datesHistory[d]);
                    }
                    Object.keys(dateDisponibili).map(d => state.datesHistory[d] = true);
                    this.setState(state);
                    swal.safeClose();
                } else {
                    swalError('Non ci sono ulteriori giorni disponibili');
                }
            })
            .catch(e => {
                swalError(e).then(_ => {
                    this.handleDismiss();
                });
            });
    }

    handleDismiss() {
        this.setState({
            selectedDate: null,
            selectedTime: null,
            dateDisponibili: {},
            startDate: 'now',
            requestDirection: 'next',
            nextButtonClicks: 0
        });
        this.state.onDismiss();
    }

    handleConfirm() {
        if (!this.state.selectedDate || !this.state.selectedTime) {
            swalError("Devi scegliere una data e un orario");
            return;
        }

        this.state.onChoose({
            data: this.state.selectedDate,
            orario: this.state.selectedTime,
            dipendenti: this.state.dateDisponibili[this.state.selectedDate].dipendenti
        });
    }

    handleChange(value) {
        this.setState({selected: value});
    }

    handleNextDays() {
        var dateList = Object.keys(this.state.dateDisponibili);
        this.needRefetch = true;
        this.setState({
            startDate: dateList[dateList.length - 1],
            requestDirection: 'next',
            nextButtonClicks: this.state.nextButtonClicks + 1
        });
    }

    handlePrevDays() {
        var dateList = Object.keys(this.state.dateDisponibili);
        this.needRefetch = true;
        this.setState({
            startDate: dateList[0],
            requestDirection: 'prev',
            nextButtonClicks: this.state.nextButtonClicks - 1,
            disableNext: false
        });
    }

    handleDayClick(dateString) {
        console.log(dateString);
        console.log(this.state.dateDisponibili[dateString].time);
        this.setState({
            selectedDate: dateString
        });
    }

    handleTimeChange(orario) {
        this.setState({
            selectedTime: orario
        })
    }

    render() {
        if (this.props.active && this.needRefetch) {
            this.needRefetch = false;
            this.fetchNewData();
        }
        if (!this.props.active) {
            this.needRefetch = true; //Necessiterà di un refresh al prossimo stato active
            return '';
        }

        const canGoPrev = this.state.nextButtonClicks > 0;
        const canGoNext = !this.props.maxVisibleDays || this.props.maxVisibleDays > Object.keys(this.state.datesHistory).length;
        return (
            <Page
                title={"Date disponibili"}
                leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                onLeftIconClick={this.handleDismiss}
                active={this.props.active}
                pageContentStyle={{
                    overflowY: 'hidden'
                }}
                content={
                    <PageWithFooterContainer>
                        <div className={"container bg-main-z2 py-3 shadow-sm"}>
                            <div className={"text-center my-2"}>
                                <button className={"btn btn-sm btn-primary mx-1 px-2 text-on-bg-primary"}
                                        onClick={this.handlePrevDays}
                                        disabled={!canGoPrev}>
                                    <FaSolidIcon name={"angle-left"}/>
                                </button>
                                <span className={"text-on-bg-main"}>Scegli il giorno</span>
                                <button className={"btn btn-sm btn-primary mx-1 px-2 text-on-bg-primary"}
                                        onClick={this.handleNextDays}
                                        disabled={!canGoNext}>
                                    <FaSolidIcon name={"angle-right"}/>
                                </button>
                            </div>
                            {
                                !canGoNext &&
                                <div className={"my-2 text-muted text-center small"}>
                                    <FaSolidIcon name={"exclamation-triangle"} className={"text-warning"}/> Non puoi
                                    visualizzare altre date future a causa dei limiti impostati dall'attività
                                </div>
                            }
                            <div className={"my-2 row p-1"}>
                                {/* Mostro le attuali date disponibili */}
                                {
                                    Object.keys(this.state.dateDisponibili).map((dateString, i) => {
                                        var giorniSettimana = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
                                        var mesi = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];
                                        var m = moment(dateString, "DD-MM-YYYY");
                                        var giorno = m.date();
                                        var mese = mesi[m.month()]; //0 Based
                                        var giornoSettimana = giorniSettimana[m.day()]; //0 Based, 0 = Domenica
                                        return (
                                            <div key={i} className={"col-2 p-0 text-center"}
                                                 onClick={this.handleDayClick.bind(this, dateString)}>
                                                <span
                                                    className={"d-block mb-2 text-uppercase text-on-bg-main"}>{giornoSettimana}</span>
                                                <div style={{minWidth: "40px"}}
                                                     className={"rounded shadow-sm p-2 text-center mx-auto d-inline-block cursor-pointer " + (this.state.selectedDate === dateString ? "bg-primary text-on-bg-primary" : "bg-white bg-main-z2 text-on-bg-main")}>
                                                    {giorno}
                                                </div>
                                                <small
                                                    className={"d-block mt-2 text-uppercase text-on-bg-main"}>{mese}</small>
                                            </div>
                                        )
                                    })

                                }
                            </div>
                        </div>

                        <div className={"container pt-4"} style={this.timesContainerStyle}>
                            <div className={"row my-2 pb-5"}>
                                {
                                    !this.state.selectedDate ? '' : this.state.dateDisponibili[this.state.selectedDate].time.map((orario, i) => {
                                        return (
                                            <div className={"col-4 px-2 text-center"} key={i}>
                                                <label
                                                    className={
                                                        "fux-radiobox badge badge-pill d-block shadow-sm py-2 " +
                                                        (this.state.selectedTime === orario ? "bg-primary text-on-bg-primary" : "bg-main-z2 text-on-bg-main")
                                                    }
                                                    style={{fontSize: "1em"}}>
                                                    <input type={"radio"} value={orario} name={"orario_prenotazione"}
                                                           checked={this.state.selectedTime === orario}
                                                           onChange={this.handleTimeChange.bind(this, orario)}/>
                                                    {this.state.selectedTime === orario ?
                                                        <FaSolidIcon name={"check-circle"}/> :
                                                        <FaRegularIcon name={"circle"}/>}&nbsp;
                                                    {orario}
                                                </label>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </PageWithFooterContainer>
                }
                footer={
                    <PageFooter className={"bg-main-z2 p-3 shadow"}>
                        <button className={"btn btn-lg btn-block btn-primary text-on-bg-primary"}
                                onClick={this.handleConfirm}>
                            {this.props.confirmText ? this.props.confirmText : "Prenota"} <FaSolidIcon
                            name={"chevron-right"}/>
                        </button>
                    </PageFooter>
                }
            />
        );
    }

}


DateChooserPage.propTypes = {
    bookInfo: PropTypes.object,
    onDismiss: PropTypes.func,
    onChoose: PropTypes.func, //arguments({data: 'DD-MM-YYYY', orario: 'HH:mm', dipendenti: [123,456,789]})
    active: PropTypes.bool,
    isDashboard: PropTypes.bool,
    maxVisibleDays: PropTypes.number
};
